
// This file is auto generated from package.json
const c = {
  "name": "TruexRefApp",
  "version": "1.7.1",
  "buildDate": "2025-11-18 20:06:46"
};

export const config = c;
export default config;
